import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import docIcon from './images/docIcon.png';
import Loading from "./loader";
import { ArrowLeftOutlined } from "@ant-design/icons";
import StateWarning from './StateWarning';

class VoteResults extends Component {
    state = {
        docs: null,
    };

    async componentDidMount() {
        const { match } = this.props;
        const meetingId = match.params.meetingId;

        const globalAccessToken = localStorage.getItem(`globalAccessToken`);
        const path = window.location.hash.split('/');
        const firstParam = path[2];

        if (firstParam) {
            if (!globalAccessToken || !globalAccessToken.startsWith(`${firstParam}`)) {
                alert("Доступ запрещен");
                window.location.href = `/#/`;
                return;
            }
        } else {
            localStorage.removeItem(`globalAccessToken`);
        }

        const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;
        try {
            const userRes = await fetch(`${API_ADDRESS}get_docs/${meetingId}/`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            });

            if (userRes.ok) {
                const docsData = await userRes.json();
                this.setState({ docs: docsData });
            } else {
                alert("Произошла ошибка. Попробуйте еще раз открыть раздел.");
                console.error('Ошибка:', userRes.statusText);
                window.history.back();
            }

            if(userRes["statusText"] === "Unauthorized") {
                alert("Время сессии истекло. Пожалуйста выполните вход.");
                document.getElementById("logoutBttn").click();
            }

        } catch (e) {
            alert("Произошла ошибка. Попробуйте еще раз открыть раздел.");
            console.log(e);
            window.history.back();
        }
    }

    handleBackClick = () => {
        window.history.back();
    };

    handleDownload = (url) => {
        const link = document.createElement('a');
        link.href = url;
        link.download = '';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    render() {
        const { docs } = this.state;
        if (!docs) {
            return <div><Loading /></div>;
        }

        const filteredDocs = docs.filter(doc => doc.is_result);

        return (
            <>
                <div className="page-container">
                    <div className="header-container">
                        <div style={{display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px'}}>
                            <div className="back-button-wrapper" onClick={this.handleBackClick}>
                                <ArrowLeftOutlined
                                    style={{fontSize: '20px', cursor: 'pointer', marginTop: '4px'}}
                                />
                            </div>
                            <h1>Итоговый протокол</h1>
                        </div>
                    </div>

                    {filteredDocs.length > 0 ? (
                        <div className="docs-list">
                            {filteredDocs.map((doc, index) => (
                                <div
                                    className="doc-card"
                                    key={doc.id}
                                    onClick={() => doc.url && this.handleDownload(doc.url)}
                                >
                                    <div className="doc-content">
                                        <b>{doc.fname}</b>
                                        <div className="doc-icon">
                                            <img src={docIcon} alt="док. файл" width="34" height="34"/>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <StateWarning message="Итоговый протокол на данный момент отсутствует"/>
                    )}
                </div>
            </>
        );
    }
}

export default withRouter(VoteResults);